import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { CalculateResult, CalculatorOccFormData, Calculators, OCC_ENDPOINTS } from '@product/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccProductCalculatorsService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  load(productCode: string): Observable<Calculators> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.calculator.get, {
      queryParams: {
        productCode,
      },
    });

    return this.http.get<Calculators>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.calculator.get),
    });
  }

  calculate(
    calculatorCode: string,
    productCode: string,
    variables: CalculatorOccFormData[],
  ): Observable<CalculateResult> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.calculator.calculate);

    return this.http.post<CalculateResult>(
      url,
      {
        calculatorCode,
        productCode,
        variables,
      },
      {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.calculator.calculate),
      },
    );
  }
}
